/**
 * Lazy Load Images
 *
 * Copyright: Jonah Digital Agency
 * Created by: Erik Uunila (erik.uunila@jonahsystems.com)
 *
 * add data-src="url-to-image"
 * add data-mobile-src="" if you want to change image for mobile devices
 *
 * init: $(element).lazyload();
 */
;(function($) {

  $.lazyload = function(el, options) {
    var element = $(el);

    element.vars = $.extend({}, $.lazyload.defaults, options);

    var $window = $(window),
        methods = {};

    $.data(el, 'lazyload', element);

    var methods = {
      init: function() {
        element.setup();
      },

      doWork: function() {
        element.replace();
      }
    };

    element.setup = function(type) {
      if (!element.hasClass(element.vars.postClass)) {
        element.addClass(element.vars.class);
      }
      element.replace();
    };

    element.replace = function() {
      var image;
      var elementTop;
      var elementBottom;
      var scrollBottom;

      elementTop = element.offset().top - element.vars.offset;
      elementBottom = elementTop + element.height() + element.vars.offset;
      scrollBottom = $window.scrollTop() + $window.height();

      if ($window.width() <= element.vars.mobile && (typeof element.attr('data-mobile-src') != 'undefined' && element.attr('data-mobile-src') !== false)) {
        image = element.data('mobile-src');
      }
      else {
        image = element.data('src');
      }

      if (element.hasClass(element.vars.class) && (element.attr('src') !== image || element.css('background-image') !== 'url("' + image + '")')) {
        if (image !== undefined && (elementTop <= scrollBottom || elementBottom <= $window.scrollTop())) {
          if (element.is('img, source') && element.attr('src') !== image) {
            element.addClass(element.vars.preClass);
            element.attr('src', image);
          }
          else {
            if (element.css('background-image') !== 'url("' + image + '")') {
              element.addClass(element.vars.preClass);
              element.css('background-image', 'url(' + image + ')');
            }
          }
          // -- Check to make sure that image has been replaced
          if (element.attr('src') === image || element.css('background-image') === 'url("' + image + '")') {
            element.removeClass(element.vars.class).removeClass(element.vars.preClass).addClass(element.vars.postClass);
          }
        }
      }
    };

    methods.init();

    $window.on('load', function() {
      setTimeout(function() {
        methods.doWork();
      }, 200);
      setTimeout(function() {
        methods.doWork();
      }, 2000);
    });

    $window.on('load scroll resize orientationChange', function() {
      methods.doWork();
    });
  };

  $.lazyload.defaults = {
    class: 'lazy-load',
    preClass: 'loading',
    postClass: 'loaded',
    mobile: 808,
    offset: 20, // -- Used to have the image load before user scrolls it into the viewport
    init: function() {}
  };

  $.fn.lazyload = function(options) {
    if (options === undefined) { options = {}; }

    return this.each(function() {
      new $.lazyload(this, options);
    });
  };

})(window.jQuery);
